import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloPiscine,cleanAloPiscine } from '@/models/alo/AloPiscine'
import { getDefaultAloConfigPiscine } from '@/models/alo/AloConfigPiscine'
import { ApiResultCode } from '@/enum/ApiResultCode'

function parsePiscineData(data:string) {
  const resp =  JSON.parse(data) as AlrContainer<AloPiscine>  
  if(resp.resultCode == ApiResultCode.Ok){
    const psn = resp.data as AloPiscine    
    if(psn?.image?.id > 1 && (!psn.images || psn.images.length == 0)) psn.images = [psn.image]
    psn.configPiscine = psn.config?{...getDefaultAloConfigPiscine(),...JSON.parse(psn.config)}:getDefaultAloConfigPiscine()
  }    
  return resp
}

function parsePiscinesData(data:string) {  
  const resp =  JSON.parse(data) as AlrContainer<Array<AloPiscine>> 
  if(resp.resultCode == ApiResultCode.Ok) {
    const acys = resp.data as Array<AloPiscine>        
    acys.forEach(psn => 
      {
        if(psn?.image?.id > 1 && (!psn.images || psn.images.length == 0)) psn.images = [psn.image]
        psn.configPiscine = psn.config?{...getDefaultAloConfigPiscine(),...JSON.parse(psn.config)}:getDefaultAloConfigPiscine()
      })   
  }    
  return resp
}

export default {
  getAllPiscine(): AxiosPromise<AlrContainer<Array<AloPiscine>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Piscine`, 
      method: 'GET',
      transformResponse: parsePiscinesData
    })
  },
  getPiscine(idOrSlug:string|number):AxiosPromise<AlrContainer<AloPiscine>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Piscine/${idOrSlug}`, 
      method: 'GET',
      transformResponse: parsePiscineData
    })
  },
  savePiscine(piscine:AloPiscine):AxiosPromise<AlrContainer<AloPiscine>> {
    cleanAloPiscine(piscine)
    if(piscine.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Piscine/${piscine.id}`, 
        method: 'PUT',
        data: piscine,
        transformResponse: parsePiscineData
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Piscine`, 
        method: 'POST',
        data: piscine,
        transformResponse: parsePiscineData
      })    
    }
  },
  deletePiscine(id:number):AxiosPromise<AlrContainer<AloPiscine>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Piscine/${id}`, 
      method: 'DELETE',
      transformResponse: parsePiscineData
    })
  }
}